import { client, gql } from 'data-provider';
import { ICategory } from 'interfaces';

interface GetAllCategoryParams {
  searchString?: string;
  start?: number;
  limit?: number;
}

export const getAllCategory = async (queryParam?: GetAllCategoryParams) => {
  const where = { query: '' };
  if (queryParam?.searchString) {
    where.query = queryParam.searchString;
  }

  const query = gql`
    query ($where: JSON, $sort: SortInput, $start: Int, $limit: Int) {
      categories(where: $where, sort: $sort, start: $start, limit: $limit) {
        data {
          id
          name
          description
        }
        total
        size
        page
      }
    }
  `;

  const variables = {
    where,
    start: queryParam && queryParam.start ? queryParam.start : 1,
    limit: queryParam && queryParam.limit ? queryParam.limit : 10,
  };
  const data = await client.request(query, variables);
  return data.categories as {
    data: ICategory[];
    page: number;
    size: number;
    total: number;
  };
};

export const getCategory = async (categoryId: string) => {
  const query = `
    query($id: ID!) {
      category(id: $id) {
        id
        name
        description
      }
    }
  `;

  const variables = { id: categoryId };
  const data = await client.request(query, variables);
  return data.category as ICategory;
};

export const getAllCategoryDropdown = async () => {
  const query = gql`
    query CategoryDropdown {
      categoryDropdown {
        id
        name
        description
        keywords
      }
    }
  `;

  const data = await client.request(query);
  return data.categoryDropdown as ICategory[];
};

export const getCategoriesByWarehouse = async (warehouseId: string) => {
  const query = `
    query getUsedCategoriesInInventories($where: JSON) {
      getUsedCategoriesInInventories(where: $where) {
        id
        name
      }
    }
  `;

  const variables = { where: { warehouse: warehouseId } };
  const data = await client.request(query, variables);
  return data.getUsedCategoriesInInventories as { id: string; name: string }[];
};

export type IImportCategoryData = Pick<ICategory, 'name' | 'description'>;

export const importCategory = async (tags: IImportCategoryData[]) => {
  const mutation = `
    mutation ($input: createInputCSVBulkCategoryInput) {
      importCSVCategory(input: $input) {
        id
      }
    }
  `;

  const variables = {
    input: { data: tags },
  };
  const createdData = await client.request(mutation, variables);
  return createdData;
};
